/**
 * Community UTM sessionStorage key + allow-listed query params.
 * Used by GoKollab + ClientPortal for traffic page-view attribution.
 */

export const COMMUNITY_UTM_SESSION_KEY = 'cp_community_utm_details'

/** Allow-listed UTM query keys only (no gclid/fbclid unless product asks later). */
export const UTM_QUERY_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const
